import { createSelector } from 'reselect'

export const getParentCategory = createSelector(
  (state) => state && state.categories && state.categories.currentParentCategory ? state.categories.currentParentCategory : null,
  (category) => category
)
